<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="600"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>edit</v-icon> Listado de registro de asistencia manual
				</v-flex>
				<v-spacer></v-spacer>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>

			<!-- Cuerpo del formulario -->
			<v-form
				@submit.prevent="save"
				v-model="valid"
				ref="form"
				lazy-validation
				>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex md12>
								<p><strong>Fecha: </strong>{{form.fecha}} </p>
							</v-flex> 
						</v-layout>
						<v-layout wrap>
						<v-flex xs6 >
							<v-text-field
							type="time"
							label="Hora ingreso mañana :"
							v-model="form.ingreso_am"
							/>
						</v-flex>
						
						<v-flex xs6 >
							<v-text-field
							type="time"
							label="Hora salida mañana"
							v-model="form.salida_am"
						/>
						</v-flex>
						<v-flex xs6 >
							<v-text-field
							type="time"
							label="Hora ingreso tarde :"
							v-model="form.ingreso_pm"
							/>
						</v-flex>
						
						<v-flex xs6 >
							<v-text-field
							type="time"
							label="Hora salida tarde"
							v-model="form.salida_pm"
						/>
						</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<small class="error--text text-required">* Los campos son obligatorios</small>
					<v-spacer></v-spacer>
					<v-btn
						@click.native="close()">
						<v-icon>cancel</v-icon> {{$t('common.cancel') }}
					</v-btn>
					<v-btn
						color="primary"
						type="submit"
						:loading="loading"
						>
						<v-icon dark>check</v-icon> {{$t('common.save') }}
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			dialog: false,
			form: {},
			valid: false,
			loading: false
		}
	},
	mounted () {
		this.$bus.$on('openDialogEditarAsistenciaAutoridad', item => {
			this.form = item
			this.dialog = true
		})
	},
	methods: {
		close () {
			this.form = {},
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialog')
			this.dialog = false
		},
		async save () {
			if (this.$refs.form.validate()) {
			if (this.form.ingreso_am || this.form.salida_am || this.form.ingreso_pm || this.form.salida_pm) {
				this.loading = true
				if(this.form.ingreso_am==undefined || !this.form.ingreso_am){this.form.ingreso_am='00:00'}
				if(this.form.salida_am==undefined || !this.form.salida_am){this.form.salida_am='00:00'}
				if(this.form.ingreso_pm==undefined || !this.form.ingreso_pm){this.form.ingreso_pm='00:00'}
				if(this.form.salida_pm==undefined || !this.form.salida_pm){this.form.salida_pm='00:00'}
				let id_funcionario=parseInt(this.$storage.get("user").id_persona)
			// SELECT control.fn_actualiza_asistencia_manual_detalle(
			//   p_id_asistencia_manual_detalle integer,
			//   p_primera_entrada character varying, 
			//   p_primera_salida character varying, 
			//   p_segunda_entrada character varying, 
			//   p_segunda_salida character varying, 
			//   p_id_funcionario integer
			//   )
			let respuesta
			let consulta=`SELECT control.fn_actualiza_asistencia_manual_detalle(${parseInt(this.form.id_detalle)},'${this.form.ingreso_am}','${this.form.salida_am}','${this.form.ingreso_pm}','${this.form.salida_pm}',${id_funcionario})`
				try {
					respuesta = await this.$service.graphql({
					query: `
						query{
						runQuery(consulta:"${consulta}"){
							respuesta
						}
						}
						`,
					});
					respuesta = respuesta.runQuery.respuesta[0].fn_actualiza_asistencia_manual_detalle;
					let resps = respuesta.split("|");
					let correcto = resps[0];
					if (correcto === "1") {
						this.$message.success("Registro exitoso.");
					} 
					else {
						this.$message.error(resps[1]);
					}
				} catch (error) {
					console.log(error);
				}
				this.loading = false
				this.close()
			}
			else {
				this.$message.warning("Debe ingresar al menos una hora");
			} 
			}
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/dialogs/EditarAsistenciaAutoridad.vue